module.exports = __webpack_public_path__ + "static/img/creator_photo.646a3d9.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/creator_bank/img/creator_photo.jpg
// module id = ZOiW
// module chunks = 0